export const cvBuilderDocumentQueryKey = ["cvBuilderDocument"] as const;

export const cvBuilderPolishComparisonQueryKey = [
  "cvBuilderPolishComparison",
] as const;
